import React from 'react';
import { Redirect, RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';

const RedirectToChangePasswordScreen = withRouter(({ location }: RouteComponentProps) =>
  <Redirect to={{ pathname: '/auth/password', search: `?redirect=${location.pathname}` }} />
);

export default RedirectToChangePasswordScreen;
